import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export type PatternStatus = 0 | 1; // Inactive=0, Active=1

export interface JobLogPatternDto {
  id: number;
  title: string;
  status: PatternStatus;
  pattern: string;
  category?: string | null;

  linkId?: number | null;
  jobLogType?: number | null;

  fromApplicationId?: number | null;
  toApplicationId?: number | null;
  linkTypeId?: number | null;

  totalMatches: number;
  lastSeenUtc?: string | null;
  createdUtc: string;
  updatedUtc?: string | null;
}

export interface UpsertJobLogPatternRequest {
  title: string;
  pattern: string;
  status: PatternStatus;
  category?: string | null;

  linkId?: number | null;
  jobLogType?: number | null;

  fromApplicationId?: number | null;
  toApplicationId?: number | null;
  linkTypeId?: number | null;

  description?: string | null;
  freshdeskArticleIds?: number[] | null;
}

export interface UnmatchedSearchRequest {
  take: number;
  linkId?: number | null;
  jobLogType?: number | null;
  fromApplicationId?: number | null;
  toApplicationId?: number | null;
}

export interface UnmatchedGroupDto {
  message: string;
  count: number;
  lastSeenUtc: string; // or Date string
  jobLogIds: number[];
}

export interface MatchPatternsRequest {
  message: string;
  linkId?: number | null;
  jobLogType?: number | null;
  fromApplicationId?: number | null;
  toApplicationId?: number | null;
  linkTypeId?: number | null;
  activeOnly?: boolean;
}

export interface MatchPatternsResponse {
  patternIds: number[];
}


@Injectable({ providedIn: 'root' })
export class JobLogPatternService {

  private url = 'joblogpattern';

  constructor(private http: HttpClient) { }

  list(q?: string, status?: PatternStatus): Observable<JobLogPatternDto[]> {
    let params = new HttpParams();
    if (q?.trim()) params = params.set('q', q.trim());
    if (status !== undefined && status !== null) params = params.set('status', String(status));
    return this.http.get<JobLogPatternDto[]>(this.url, { params });
  }

  create(req: UpsertJobLogPatternRequest): Observable<JobLogPatternDto> {
    return this.http.post<JobLogPatternDto>(this.url, req);
  }

  update(id: number, req: UpsertJobLogPatternRequest): Observable<JobLogPatternDto> {
    return this.http.put<JobLogPatternDto>(`${this.url}/${id}`, req);
  }

  setStatus(id: number, status: PatternStatus): Observable<void> {
    return this.http.patch<void>(`${this.url}/${id}/status`, { status });
  }

  search(req: UnmatchedSearchRequest): Observable<UnmatchedGroupDto[]> {
    return this.http.post<UnmatchedGroupDto[]>(this.url + '/unmatched', req);
  }

  delete(id: number) {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  matchPatterns(req: MatchPatternsRequest) {
  return this.http.post<MatchPatternsResponse>(
    `${this.url}/match-patterns`,
    req
  );
}

  test(req: {
    pattern: string;
    message: string;
    enforceOrder: boolean;
    jobLogType: number | null;
    fromApplicationId: number | null;
    toApplicationId: number | null;
    linkTypeId: number | null;
  }): Observable<{
    isMatch: boolean;
    orderMatch: boolean;
    chunks: string[];
    terms: string[];
    notes?: string | null;
  }> {
    return this.http.post<any>(this.url + `/test`, req);
  }
}
